export const LANGUAGE_KEY = 'ee.interfaceLanguage.v1';
export const isInterfaceLanguage = value => value === 'pl' || value === 'en';

export function readLanguagePreference(getStorage = () => window.localStorage) {
  try {
    const value = getStorage().getItem(LANGUAGE_KEY);
    return isInterfaceLanguage(value) ? value : 'pl';
  } catch (error) {
    return 'pl';
  }
}

export function writeLanguagePreference(language, getStorage = () => window.localStorage) {
  if (!isInterfaceLanguage(language)) return false;
  try {
    getStorage().setItem(LANGUAGE_KEY, language);
    return true;
  } catch (error) {
    return false;
  }
}
